(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer-r2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header-r2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-landing"] && !Shopify.designMode) return;
  try {
    
function initVelora(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const feature=root.querySelector('.vl-feature');root.querySelectorAll('.vl-thumb').forEach(b=>b.addEventListener('click',()=>{feature.src=b.dataset.image;feature.alt=b.dataset.alt;root.querySelectorAll('.vl-thumb').forEach(x=>{x.classList.toggle('selected',x===b);x.setAttribute('aria-pressed',String(x===b))})}));const zoom=root.querySelector('.vl-zoom');root.querySelector('.vl-mainimage').addEventListener('click',()=>{zoom.querySelector('img').src=feature.src;zoom.querySelector('img').alt=feature.alt;zoom.showModal()});root.querySelectorAll('dialog').forEach(d=>{d.querySelector('.vl-close').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d&&e.clientX<d.getBoundingClientRect().left)d.close()})});const drawer=root.querySelector('.vl-drawer');
const message=drawer.querySelector('.vl-cart-message');
const checkout=drawer.querySelector('.vl-checkout');
const add=root.querySelector('.vl-add');
const addLabel=add.innerHTML;
const route=window.Shopify?.routes?.root||'/';
let busy=false;
let currentCart=null;
const money=(cents,currency)=>new Intl.NumberFormat(root.dataset.locale||'en-US',{style:'currency',currency:currency||root.dataset.currency||'USD'}).format(cents/100);
const status=(text)=>{message.textContent=text;message.hidden=!text};
const request=async(path,body)=>{const response=await fetch(route+path,body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{cache:'no-store'});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||root.dataset.error);return data};
const setBusy=(value)=>{busy=value;add.disabled=value||root.dataset.ready!=='true';add.innerHTML=value?root.dataset.adding:addLabel;checkout.disabled=value||!currentCart?.item_count;drawer.querySelectorAll('.vl-qty button,.vl-remove').forEach(b=>b.disabled=value)};
const renderCart=(cart)=>{currentCart=cart;const list=drawer.querySelector('.vl-cart-items');list.replaceChildren();drawer.querySelector('.vl-cart-empty').hidden=cart.item_count>0;drawer.querySelector('.vl-cart-count').textContent=cart.item_count;drawer.querySelector('.vl-cart-total').textContent=money(cart.total_price,cart.currency);for(const item of cart.items){const row=document.createElement('div');row.className='vl-cart-item';const img=document.createElement('img');img.src=String(item.product_id)===root.dataset.productId?root.dataset.productImage:(item.featured_image?.url||item.image||root.dataset.productImage);img.alt=item.product_title;img.width=90;img.height=90;row.append(img);const copy=document.createElement('div');copy.className='vl-cart-copy';const title=document.createElement('b');title.textContent=String(item.product_id)===root.dataset.productId?root.dataset.productName:item.product_title;copy.append(title);if(item.variant_title&&item.variant_title!=='Default Title'){const variant=document.createElement('p');variant.textContent=item.variant_title;copy.append(variant)}const price=document.createElement('div');price.className='vl-cart-price';price.textContent=money(item.final_line_price,cart.currency);copy.append(price);const controls=document.createElement('div');controls.className='vl-cart-controls';const qty=document.createElement('div');qty.className='vl-qty';for(const delta of [-1,1]){const button=document.createElement('button');button.type='button';button.textContent=delta<0?'−':'+';button.setAttribute('aria-label',(delta<0?root.dataset.decrease:root.dataset.increase)+' — '+item.product_title);button.addEventListener('click',()=>change(item.key,item.quantity+delta));qty.append(button);if(delta<0){const number=document.createElement('span');number.textContent=item.quantity;qty.append(number)}}controls.append(qty);const remove=document.createElement('button');remove.type='button';remove.className='vl-remove';remove.textContent=root.dataset.remove;remove.setAttribute('aria-label',root.dataset.remove+' — '+item.product_title);remove.addEventListener('click',()=>change(item.key,0));controls.append(remove);copy.append(controls);row.append(copy);list.append(row)}checkout.disabled=busy||!cart.item_count};
const change=async(id,quantity)=>{if(busy)return;setBusy(true);status(root.dataset.loading);try{renderCart(await request('cart/change.js',{id,quantity}));status('')}catch(error){status(error.message)}finally{setBusy(false)}};
const openCart=async()=>{if(busy)return;drawer.showModal();setBusy(true);status(root.dataset.loading);try{renderCart(await request('cart.js'));status('')}catch(error){status(error.message)}finally{setBusy(false)}};
root.querySelector('.vl-cart-trigger').addEventListener('click',openCart);
root.querySelector('.vl-continue').addEventListener('click',()=>drawer.close());
add.addEventListener('click',async()=>{if(busy||root.dataset.ready!=='true'||!root.dataset.variant)return;drawer.showModal();setBusy(true);status(root.dataset.loading);try{await request('cart/add.js',{items:[{id:root.dataset.variant,quantity:1}]});renderCart(await request('cart.js'));status('')}catch(error){status(error.message);try{renderCart(await request('cart.js'))}catch{}}finally{setBusy(false)}});
root.querySelector('.vl-menu-toggle').addEventListener('click',e=>{const open=root.querySelector('.vl-nav').classList.toggle('open');e.currentTarget.setAttribute('aria-expanded',String(open))});root.querySelectorAll('.vl-nav a').forEach(a=>a.addEventListener('click',()=>{root.querySelector('.vl-nav').classList.remove('open');root.querySelector('.vl-menu-toggle').setAttribute('aria-expanded','false')}));root.querySelectorAll('[data-slide]').forEach(b=>b.addEventListener('click',()=>{const track=root.querySelector('.vl-quote-track');track.scrollBy({left:Number(b.dataset.slide)*(track.querySelector('.vl-quote').getBoundingClientRect().width+22),behavior:'smooth'})}))}
document.querySelectorAll('.vl').forEach(initVelora);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.vl').forEach(initVelora));

  } catch(e) { console.error(e); }
})();
})();
